export default "__VITE_ASSET__CoMMEDdd__"